<template>
	<page class="vehicle-list" title="Nyheder">
		<button-view slot="tools" label="Opret" @click="createNews" />
		<new-table-view ref="table" :columns="[
			{
				label: 'Dato',
				name: 'created',
				filter: 'timestamp'
			},
			{
				label: 'Overskrift',
				name: 'title'
			},
			{
				label: 'Uddrag',
				name: 'content'
			},
			{
				label: 'Vedhæftede filer',
				name: ['_embedded', 'file_count'],
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: 'Slet'
				}
			},
		]" :items="items" @itemClick="itemClick" @delete="itemDelete" :pagination="pagination">
		</new-table-view>
	</page>
</template>

<script>
	import Window from '../windows/NewsWindow'
	import NewTableView from '../views/NewTableView'

	import ContactModel from '../model/Contact'
	import ContactWindow from '../windows/ContactWindow'

	import { bus } from '../../bus'

    export default {
		watch: {
			pagination: function (n, o) {
				if (n.page == o.page && n.index == o.index) return;
				this.update();
			}
		},
		props: [],
		components: {
			newTableView: NewTableView
		},
		methods: {
			async createNews() {
				const self = this;

				this.$store.state.windowStack.push(Window, {
					onChange: function (ent) {
						console.log('change', ent);

						self.update();
					},
					async submit(ent) {
						try {
							await self.axios.post('/news/', ent);

							self.$store.state.windowStack.pop();
							self.update();
						} catch (e) {
							console.error(e);
							alert('Der opstod en fejl');
						}
					},
				});
			},
			async update() {
				this.controller.abort();
				this.controller = new AbortController();

				this.items = null;

				const { data } = await this.axios.get(`/news/`, {
					signal: this.controller.signal
				});

				this.items = data._items;
			},
			async itemClick(item) {
				const self = this;
				const ent = (await self.axios.get(`/news/${item.id}/`)).data;

				self.$store.state.windowStack.push(Window, {
					value: ent, 
					submit: async function (ent) {
						try {
							await self.axios.put(`/news/${item.id}/`, ent);

							self.$store.state.windowStack.pop();
							self.update();
						} catch (e) {
							console.error(e);
							alert('Der opstod en fejl');
						}
					}
				});
			},
			async itemDelete(item) {
				if (confirm('Sikker?')) {
					var self = this;

					this.axios
						.delete('/news/' + item.id + '/')
						.then(function () {
							self.update();
						}, function () {
							alert('Could not delete the item');
						});
				}
			},
		},
		data: function () {
			return {
				controller: new AbortController(),
				pagination: {
					page: 1,
					index: null,
					count: 0
				},
				items: [],
				columns: []
			};
		},
		mounted: function () {
			//this.axios.put('/activity/contacts/');

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			this.update();
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.tool-text {
		display: block;
		float: left;
		margin-left: 10px;
		height: 40px;
		border-radius: 20px;
		padding-left: 20px;
		border: 1px solid #cecece;
	}

	.button {
		float: left;
		margin-left: 10px;
	}
</style>